import { v4 as uuidv4 } from 'uuid';

const URL_IMAGES = 'https://jcorporation.github.io/webradiodb/db/pics/';

const URL_STATIONS =
  'https://jcorporation.github.io/webradiodb/db/index/webradios.min.json';

export const fetchJsonData = async () => {
  try {
    const response = await fetch(URL_STATIONS);
    if (!response.ok) {
      throw new Error(`Failed to fetch JSON data: ${response.statusText}`);
    }

    const data = await response.json();

    // Map the JSON data to the field names in the RadioBrowser station struct
    const mappedData = Object.entries(data).map(([key, value]) => ({
      type: 'web-radio-db',
      stationuuid: uuidv4(),
      votes: 0,
      clickcount: 0,
      description: value.Description || '',
      tags: value.Genre || [],
      name: value.Name || '',
      favicon: URL_IMAGES + value.Image || '',
      homepage: value.Homepage || '',
      country: value.Country || '',
      state: value.Region || '',
      language: value.Languages || [],
      codec: value.Codec || '',
      bitrate: value.Bitrate || 0,
      lastchangetime_iso8601: value['Last-Modified']
        ? new Date(value['Last-Modified'] * 1000).toISOString()
        : null,
      url_resolved: value.StreamUri || '',
      url: value.StreamUri || '',
    }));

    return mappedData;
  } catch (error) {
    console.error('Error fetching WebRadioDB JSON data:', error);
    return [];
  }
};
